const zIndices = {
  z1: 'z-[1]',
  z2: 'z-[2]',
  z3: 'z-[3]',
  z4: 'z-[4]',
  z5: 'z-[5]',
  z6: 'z-[6]'
};

export const baseAvatarClasses = width =>
  `${width} relative rounded-full relative text-[11px] flex items-center text-white justify-center uppercase font-hmedium`;

export function UserAvatar({ user, userIndex = 0, width = 'w-[28px] h-[28px]', ping }) {
  const defaultClasses = baseAvatarClasses(width);
  const mainClasses = `relative border border-white ${user.avatar_classes || 'bg-slate-400'} ${defaultClasses} [&>[data-state]]:${zIndices[`z-${userIndex}`] || ''} hover:z-[100]`;

  return user.blob_key ? (
    <span className={mainClasses}>
      {ping && <div className="z-[2] absolute top-0 left-0">{ping}</div>}
      <img className={`${defaultClasses}`} src={`/attachments/${user.blob_key}`} />
    </span>
  ) : (
    <span className={mainClasses}>
      {ping && <div className="z-[2] absolute top-0 left-0">{ping}</div>}
      {user.initials}
    </span>
  );
}
